"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const React = __importStar(require("react"));
function getOptions(locationGroup) {
    return (0, lodash_1.map)((0, lodash_1.keys)(locationGroup), (key) => {
        return (React.createElement("option", { key: key, value: `${key}` }, locationGroup[key]));
    });
}
exports.default = (props) => {
    const { name, value, country, onChange, className } = props;
    const selectValue = value || '';
    if (country === 'United States') {
        return (React.createElement("div", { className: "SelectBox" },
            React.createElement("select", { className: 'SelectBox-options ' + className, name: name, value: selectValue, onChange: onChange },
                React.createElement("option", { value: "" }, "- Select -"),
                getOptions(GROUPED_LOCATIONS.usStates),
                React.createElement("option", { value: "-1", disabled: true }, "- US Territories -"),
                getOptions(GROUPED_LOCATIONS.usTerritories))));
    }
    if (country === 'Canada') {
        return (React.createElement("div", { className: "SelectBox" },
            React.createElement("select", { className: 'SelectBox-options ' + className, name: name, value: selectValue, onChange: onChange },
                React.createElement("option", { value: "" }, "- Select -"),
                getOptions(GROUPED_LOCATIONS.canadianProvinces))));
    }
    return (React.createElement("input", { type: "text", value: selectValue, maxLength: 30, name: name, onChange: onChange, className: 'Input ' + className }));
};
const GROUPED_LOCATIONS = {
    usStates: {
        AL: 'Alabama',
        AK: 'Alaska',
        AZ: 'Arizona',
        AR: 'Arkansas',
        CA: 'California',
        CO: 'Colorado',
        CT: 'Connecticut',
        DE: 'Delaware',
        DC: 'District Of Columbia',
        FL: 'Florida',
        GA: 'Georgia',
        HI: 'Hawaii',
        ID: 'Idaho',
        IL: 'Illinois',
        IN: 'Indiana',
        IA: 'Iowa',
        KS: 'Kansas',
        KY: 'Kentucky',
        LA: 'Louisiana',
        ME: 'Maine',
        MD: 'Maryland',
        MA: 'Massachusetts',
        MI: 'Michigan',
        MN: 'Minnesota',
        MS: 'Mississippi',
        MO: 'Missouri',
        MT: 'Montana',
        NE: 'Nebraska',
        NV: 'Nevada',
        NH: 'New Hampshire',
        NJ: 'New Jersey',
        NM: 'New Mexico',
        NY: 'New York',
        NC: 'North Carolina',
        ND: 'North Dakota',
        OH: 'Ohio',
        OK: 'Oklahoma',
        OR: 'Oregon',
        PA: 'Pennsylvania',
        RI: 'Rhode Island',
        SC: 'South Carolina',
        SD: 'South Dakota',
        TN: 'Tennessee',
        TX: 'Texas',
        UT: 'Utah',
        VT: 'Vermont',
        VA: 'Virginia',
        WA: 'Washington',
        WV: 'West Virginia',
        WI: 'Wisconsin',
        WY: 'Wyoming',
    },
    usTerritories: {
        AS: 'American Samoa',
        FM: 'Federated States Of Micronesia',
        GU: 'Guam',
        MH: 'Marshall Islands',
        MP: 'Northern Mariana Islands',
        PW: 'Palau',
        PR: 'Puerto Rico',
        VI: 'Virgin Islands',
    },
    canadianProvinces: {
        AB: 'Alberta',
        BC: 'British Columbia',
        MB: 'Manitoba',
        NB: 'New Brunswick',
        NL: 'Newfoundland and Labrador',
        NS: 'Nova Scotia',
        ON: 'Ontario',
        PE: 'Prince Edward Island',
        QC: 'Quebec',
        SK: 'Saskatchewan',
        NT: 'Northwest Territories',
        NU: 'Nunavut',
        YT: 'Yukon',
    },
};
